module.exports = __webpack_public_path__ + "img/insights.74349c22.jpg";